import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { X, ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";

export default function ReleaseBanner() {
  const [release, setRelease] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("raava_release_dismissed")) {
      setDismissed(true);
      return;
    }
    api.get("/changelog").then((r) => setRelease(r.data[0])).catch(() => {});
  }, []);

  const close = () => {
    sessionStorage.setItem("raava_release_dismissed", "1");
    setDismissed(true);
  };

  return (
    <AnimatePresence>
      {release && !dismissed && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ delay: 1.8, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-6 right-6 z-50 max-w-sm"
          data-testid="release-banner"
        >
          <div className="relative bg-[#0A0A0A]/90 backdrop-blur-xl border border-[#00FF66]/40 p-6 pr-12 shadow-[0_0_30px_rgba(0,255,102,0.12)]">
            <span className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#00FF66] to-transparent" />
            <p className="text-[9px] uppercase tracking-[0.3em] text-[#00FF66] mb-2 flex items-center gap-2">
              <span className="w-1.5 h-1.5 bg-[#00FF66] animate-pulse" /> New Release
            </p>
            <p className="font-display text-sm text-[#F4F4F5] mb-1" style={{ fontWeight: 700 }}>
              v{release.version} — {release.title}
            </p>
            <p className="text-[11px] text-[#A1A1AA] mb-4">{release.date}</p>
            <Link
              to="/changelog"
              className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.25em] text-[#00F0FF] hover:text-[#00FF66] transition-colors duration-300"
              data-testid="release-banner-link"
            >
              Release Notes <ArrowUpRight className="w-3 h-3" />
            </Link>
            <button
              onClick={close}
              className="absolute top-3 right-3 text-[#A1A1AA] hover:text-[#F4F4F5] transition-colors duration-300"
              data-testid="release-banner-close"
              aria-label="Close banner"
            >
              <X className="w-3.5 h-3.5" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
